// @flow
import React, {Component} from 'react';
import styled from 'styled-components';
import createDebugger from 'debug';
import { toLower } from 'trustar/utils';
const debug = createDebugger('app:components:ClearableSearchBar'); // eslint-disable-line no-unused-vars
import {
  Icon,
  IconLookup,
} from 'trustar-2.0/components';
import { DefaultTheme } from 'trustar-2.0/themes';
import type { ThemeType } from 'trustar-2.0/types';

// Style
const StyledSearchBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;

  > div {
    width: 100%;
    position: relative;

    .closeIcon {
      position: absolute;
      top: calc(50% - 6px);
      right: 1rem;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .searchInput {
    input {
    width: 100%;
    border: transparent;
    padding: 0.5rem 0.5rem 0.5rem 1.25rem;
    background: ${({theme}) => theme.ThemeColors.SEARCH_BAR_INPUT.X500};
    color: ${({theme}) => theme.ThemeColors.TEXT.hex};
    border-radius: 0;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    height: 2.67rem;
   }
  }

    :focus, :active {
    }

  .searchButtonEnd {
    width: 4rem;
    height: 2.67rem;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background-color: ${({theme}) => theme.ThemeColors.SECONDARY.X400};
    color: ${({theme}) => theme.ThemeColors.PRIMARY.buttonText };
    border-bottom-right-radius: 4px;
    border-top-right-radius: 4px;
    padding: 0 1.5rem;
  }

  .searchButtonEnd:hover {
    background-color: ${({theme}) => theme.ThemeColors.SECONDARY.X400};
    cursor: pointer;
  }
`;

const initialValues = {
  value: '',
  theme: DefaultTheme,
};

// Bindings
type SearchBarProps = {
  value: string,
  onChange?: Function,
  onClear?: Function,
  onSubmit?: Function,
  /*
   useInnerState - You can either bind the input value to some outside prop and supply change and
   submit handlers, or allow internal state and have the submit button send back
   the value
   */
  useInnerState?: boolean,
  theme: ThemeType,
};

class ClearableSearchBar extends Component {
  props: SearchBarProps;
  static defaultProps = initialValues;
  state = {
    value: '',
  };

//  ----Template----

  render() {
    const {onChange, onClear, onSubmit, useInnerState, value, theme} = this.props;
    const searchValue = useInnerState ? this.state.value : value;
    return (
      <StyledSearchBar>
        <div className={'searchInput'}>
          <input
            type='text'
            value={searchValue}
            onChange={useInnerState ? this.handleInternalFilter : onChange}
            />
          {searchValue && (
            <div className={'closeIcon'} onClick={onClear}>
              <Icon icon={IconLookup.CROSS} />
            </div>
          )}
        </div>
        <div className={'searchButtonEnd'} onClick={onSubmit}>
          <Icon icon={IconLookup.MAGNIFIER} />
        </div>
      </StyledSearchBar>
    );
  }

// ----Lifecycle Hooks----

// ----Methods----

  handleInternalFilter = (e: Object) => {
    const value = toLower(e.target.value);
    this.setState(() => ({ value }));
  };
}

// export -- Only if this component MUST be connected at declaration. RARE.
// export default connect(mapStateToProps, dispatchProps)(ClearableSearchBar);

export {ClearableSearchBar};



// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/ClearableSearchBar.js